import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const chapters = [
  {
    num: "01",
    title: "Mappe offline, zero segnale",
    text: "Scarica le mappe vettoriali di tutto il mondo e naviga tra sterrati, mulattiere e guadi anche dove il telefono non prende. Fondamentale in enduro e 4x4, dove il campo non c'è mai.",
    img: "https://static.prod-images.emergentagent.com/jobs/0380b2b5-443d-422e-9008-bfe58ac5771e/images/38b4fc57f116b5fc7aac3657f656cbfab045553dc26e4678ae215bd58163aaaf.jpeg",
    align: "left",
  },
  {
    num: "02",
    title: "Tracciati per enduro e 4x4",
    text: "Pendenze, tipo di fondo, guadi e sentieri tecnici: prepara i tuoi giri offroad con precisione millimetrica. Ovviamente funziona alla grande anche per chi va in MTB o a piedi — a loro vogliamo bene lo stesso.",
    img: "https://images.unsplash.com/photo-1569670380585-19bb0feec807?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHw0eDQlMjBvZmZyb2FkJTIwdmVoaWNsZSUyMGRyaXZpbmclMjBkZXNlcnQlMjBkdW5lc3xlbnwwfHx8fDE3ODQ2NTE3NTR8MA&ixlib=rb-4.1.0&q=85",
    align: "right",
  },
  {
    num: "03",
    title: "Importa ed esporta GPX",
    text: "Pianifica il roadbook a casa, carica la traccia GPX su OsmAnd e seguila sul manubrio o sul cruscotto. Condividi il percorso con tutto il gruppo prima di partire.",
    img: "https://play-lh.googleusercontent.com/1iXFKI9AvJ0h6WVkhSyWZCE4ZPi2jSGHfLHS5M58xMLmsygAac9u-quVI7txagk0gyVkCYk3xPfqsWNVMB3TZQ=w1080-rw",
    align: "left",
    screenshot: true,
  },
];

function ParallaxImage({ src, alt, screenshot }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  if (screenshot) {
    return (
      <div ref={ref} className="relative overflow-hidden rounded-[2rem] h-[340px] md:h-[520px] border border-foreground/10 bg-[#132218] flex items-center justify-center">
        <img src={src} alt={alt} className="h-[88%] w-auto object-contain rounded-2xl shadow-2xl" />
      </div>
    );
  }
  return (
    <div ref={ref} className="relative overflow-hidden rounded-[2rem] h-[340px] md:h-[520px] border border-foreground/10">
      <motion.img style={{ y }} src={src} alt={alt} className="absolute inset-0 w-full h-[130%] object-cover" />
    </div>
  );
}

function Chapter({ ch, index }) {
  const isRight = ch.align === "right";
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
      <div className={`md:col-span-7 ${isRight ? "md:order-2" : ""}`}>
        <ParallaxImage src={ch.img} alt={ch.title} screenshot={ch.screenshot} />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className={`md:col-span-5 ${isRight ? "md:order-1 md:pr-6" : "md:pl-6"}`}
      >
        <span className="font-display font-black text-7xl md:text-8xl stroke-text block leading-none">{ch.num}</span>
        <h3 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mt-6 leading-none">{ch.title}</h3>
        <p className="text-muted-foreground text-lg mt-5 max-w-md leading-relaxed">{ch.text}</p>
      </motion.div>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-24 md:py-40 max-w-[1600px] mx-auto px-6 md:px-12" data-testid="manifesto">
      <div className="max-w-3xl mb-20 md:mb-32">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-primary uppercase tracking-[0.3em] text-xs font-semibold mb-6"
        >
          Cosa imparerai
        </motion.p>
        <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
          Tre pilastri per non perdere mai <span className="font-serif-editorial italic font-normal">la rotta</span>.
        </h2>
      </div>
      <div className="space-y-28 md:space-y-40">
        {chapters.map((ch, i) => (
          <Chapter key={ch.num} ch={ch} index={i} />
        ))}
      </div>
    </section>
  );
}
